import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Plugin Manager/Script";
import * as React from 'react';
export default {
  Content,
  React
};